//Sistema para modificar acceder y modificar datos de la base de datos
import axios from "axios";
import { baseURL } from "@/general";
const adminApi = axios.create({
  baseURL,
});

//// Inicio de sesión
//login
export const userLogin = async (values) => {
  try {
    const response = await adminApi.post("general/login", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const restorePassword = async (values) => {
  try {
    const response = await adminApi.post("general/forgottenPassword", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
}

export const verifytoken = async (values) => {
  try {
    const response = await adminApi.post("general/validarTokenPassword", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response
  }
}

export const setNewPassword = async (values) => {
  try {
    const response = await adminApi.post("general/setPassword", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
}

export const changeAdminPassword = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = {
    headers: {'x-api-key': token} 
  };
  try {
    const response = await adminApi.post("general/changeAdminPassword", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
}

//verificación de acceso
export const verificaAcceso = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("general/verificaAcceso", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};
// verifica aviso de privacidad
export const validaAvisoPrivacidad = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("general/validaAvisoPrivacidad",config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const confirmaAvisoPrivacidad = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "general/confirmaAvisoPrivacidad",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Semestre
export const insertPeriodo = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "semestre/insertarSemestre",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updatePeriodo = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "semestre/modificarSemestre",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

////Obtiene los semestres registrados
export const getSemestres = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("semestre/getSemestres", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

////obtiene TODOS los datos de un semestre en específico
export const getSemestre = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "semestre/getSemestre",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Obtiene el semestre actual
export const getSemestreActual = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      "semestre/getSemestreActual",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Profesores
export const getCatalogoProfesores = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("profesor/getCatalogoProfesores", 
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getProfesores = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("profesor/getProfesores", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertProfesores = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "profesor/insertarProfesor",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateProfesor = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "profesor/modificarProfesor",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateEstatus = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "profesor/cambiarEstatusProfesor",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateMasiveProfesores = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "profesor/registrarProfesoresCSV",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const validateProfesor = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "profesor/validaProfesor",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};
// Alumnos
export const getCatalogoAlumnos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("alumno/getCatalogoAlumnos", values,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getAlumnos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("alumno/getAlumnos",values ,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertAlumnos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "alumno/insertarAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateAlumno = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "alumno/modificarAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateEstatusAlumnos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "alumno/cambiarEstatusAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateMasiveAlumnos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "alumno/registroAlumnoCSV",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const validateAlumno = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("alumno/validaAlumno", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Grupos
export const getGrupos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("grupo/getGrupos", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertGrupo = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("grupo/insertarGrupo", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateGrupo = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "grupo/modificarGrupo",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getCatalogoGruposByPeriodo = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("grupo/getCatalogoGruposbyPeriodo", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const liberarVacantes = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("grupo/liberarVacantes", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getSalones = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("salon/getSalones", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Examen Titulacion
export const insertExamenTitulacion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "examenTitulacion/insertarExamenTitulacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getExamenTitulacion = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      "examenTitulacion/getExamenTitulacion",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};
export const getExamenTitulacionVacantes = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      "examenTitulacion/getExamenTitulacionVacantes",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateExamenTitulacion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "examenTitulacion/modificarConfiguracionExamenTitulacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateEstatusExamenTitulacion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "examenTitulacion/cambiarEstatusExamenTitulacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getListaInscritos = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "grupo/getListaInscritos",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertAlumnoExamen = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "registroExamenTitulacion/registroExamenTitulacionAdministrador",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getRegistrosExamenesByFecha = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "registroExamenTitulacion/getRegistrosExamenTitulacionByFecha",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const pagoAlumnoExamen = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "RegistroExamenTitulacion/pagoExamenTitulacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const calificarAlumnoExamen = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "RegistroExamenTitulacion/calificarExamenTitulacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


// Actualizar nivel indioma
export const insertMasiveNivel = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "nivelInicial/modificarNivelInicialCSV",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateNivelInicial = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "nivelInicial/modificarNivelInicial",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Catalogos
////Obtiene los niveles registrados
export const getNiveles = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("nivel/getNiveles", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

//// Obtiene el catalogo de dependecias UNAM
export const getDependencias = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("dependencia/getDependencias", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};
//Periodos

export const insertPeriodoInscripcion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "periodoInscripcion/insertarPeriodoInscripcion",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updatePeriodoInscripcion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "periodoInscripcion/editarPeriodoInscripcion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getPeriodosInscripcion = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.get(
      "periodoInscripcion/getPeriodosInscripcion",
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
}

// Obtiene el catalogo de asignaturas
export const getAsignaturas = async() => {
  let token = sessionStorage.getItem("token");
  const config = {headers: {"x-api-key": token}};
  try{
    const response = await adminApi.get("asignatura/getAsignaturas"
      ,config
    );
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}

// INSCRIPCION A GRUPOS
export const getInscritosGrupos = async(values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "inscripcion/getInscritosByPeriodo",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
}

export const insertInscripcion = async(values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const rensponse = await adminApi.post(
      "inscripcion/inscribirAlumno",
      values,
      config
    );
    return rensponse;
  } catch (error) {
    const response = error.response;
    return response;
  }
}

export const calificarAlumnoInscripcion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "inscripcion/procesaCalificacionInscripcion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const pagoInscripcion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "inscripcion/procesaPagoInscripcion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateInscripcion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "inscripcion/cambioInscripcion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

//Get Constancia Licenciatura
export const getConstanciasLicenciatura = async () => {
  const token = sessionStorage.getItem("token");
  const config = {headers: {"x-api-key":token } }

  try {
    const response = await adminApi.post("RegistroExamenTitulacion/getConstanciasLicenciatura",{} ,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
}


//// Auxiliares
// reset contraseñas
export const resetPassword = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("general/resetPassword", values,config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};
// constancias de manera masiva
export const sendConstanciaMassive = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "RegistroExamenTitulacion/envioMasivoConstancias",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getListaRegistrosExamen = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "RegistroExamenTitulacion/listaRegistrosExamen",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};
// enviar constancias individuales
export const sendConstancia = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "registroExamenTitulacion/enviarConstancia",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const downloadConstancia = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "registroExamenTitulacion/descargarConstancia",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};



//// Encuestas Grupos
// preguntas
export const getPreguntas=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.post("preguntaEncuesta/getPreguntasByCategoria",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
};
export const insertPreguntaEncuesta=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.post("preguntaEncuesta/insertarPregunta",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}
export const updateEstatusPregunta=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key ":token}};
  try{
    const response = await adminApi.post("preguntaEncuesta/cambiarEstatus",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}


export const addPreguntaComplementaria=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key ":token}};
  try{
    const response = await adminApi.post("preguntaEncuesta/agregaPreguntaComplementaria",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}

export const changeOrdenPreguntasComplementarias=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key ":token}};
  try{
    const response = await adminApi.post("preguntaEncuesta/cambiarOrdenPreguntasComplementarias",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}

export const changeOrdenPreguntas=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key ":token}};
  try{
    const response = await adminApi.post("preguntaEncuesta/cambiarOrdenPreguntas",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}







//categorias
export const getCategoriaEncuesta=async()=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.get("categoriaEncuesta/getCategorias",config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}

export const getCatalogoCategoriaEncuesta=async()=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.get("categoriaEncuesta/getCatalogoCategorias",config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}


export const insertCategoriaEncuesta=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.post("categoriaEncuesta/insertarCategoria",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}
export const cambiarEstatusCategoria=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key ":token}};
  try{
    const response = await adminApi.post("categoriaEncuesta/cambiarEstatus",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}
export const editCategoriaEncuesta=async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.post("categoriaEncuesta/cambiarOrdenCategorias",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}
//Validar encuesta creada
export const getValidaEncuesta=async()=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.get("semestreEncuesta/validaSemestreEncuesta",config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}
export const insertSemestreEncuesta=async()=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.get("semestreEncuesta/registrarSemestreEncuesta",config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}
export const getVisualizarEncuesta =async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  try{
    const response = await adminApi.post("semestreEncuesta/visualizarEncuesta",values,config);
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}

export const getReporteEncuesta =async(values)=>{
  let token = sessionStorage.getItem("token");
  const config = {headers:{"x-api-key":token}};
  const { tipoReporte } = values
  try{
    let response
    if (tipoReporte === '1') {
      response = await adminApi.post("respuestaEncuesta/reporteRespuestaEncuesta",values,config);
    }else if (tipoReporte === '2') {
      response = await adminApi.post("respuestaEncuesta/reporteEncuestaComentarios",values,config);
    }
    return response;
  }
  catch(error){
    const response = error.response;
    return response;
  }
}
//Manuales de usuario
export const getManualesUsuario = async ()=> {
  const token = sessionStorage.getItem("token")
  const config = { headers: { "x-api-key": token}};
  try {
    const response = await adminApi.get("manualesUsuario/getManualUsuario",config);
    return response
  } catch(error){
    const response = error.response
    return response
  }
}

export const insertarManualUsuario = async (values) => {
  const token = sessionStorage.getItem("token")
  const config = { headers: { "x-api-key": token}}
  try{
    const response = await adminApi.post('manualesUsuario/agregarManualUsuario',values,config)
    return response
  }
  catch(error){
    const response = error.response;
    return response;
  }
}

export const editarManualUsuario = async (values) => {
  const token = sessionStorage.getItem("token")
  const config = { headers: { "x-api-key": token}}
  try{
    const response = await adminApi.post('manualesUsuario/editarManualUsuario',values,config)
    return response
  }
  catch(error){
    const response = error.response;
    return response;
  }
}

export const descargarManualUsuario = async () => {
  const token = sessionStorage.getItem("token")
  const config = { headers: { "x-api-key": token}}
  try{
    const response = await adminApi.post('manualesUsuario/descargarManualUsuario',{},config)
    return response
  }
  catch(error){
    const response = error.response;
    return response;
  }

}





// Recursos Visuales
export const getRecursosVisuales = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("recursosVisuales/getRecursosVisuales", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertRecursoVisual = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("recursosVisuales/agregarRecursoVisual", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateRecursoVisual = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("recursosVisuales/editarRecursoVisual", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateEstatusRecursoVisual = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("recursosVisuales/cambiarEstatusRecursoVisual", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// FORMATO DE PAGO
export const generarFormatoPagoService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("general/generaFichaPago", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

  
// Administracion de fechas de examen de titulacion
export const updateFechasExamenTitulacion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "fechaExamenTitulacion/agregarFechaExamenTitulacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getFechasExamenByTyipo = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("fechaExamenTitulacion/getFechasExamenesTitulacionByTipo", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getCatalogoFechasExamenByTyipo = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("fechaExamenTitulacion/getCatalogoFechasExamenesTitulacionByTipo", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


export const deleteFechaExamen = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("fechaExamenTitulacion/eliminarFechaExamenTitulacion", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};



export const getHistoriaAcademica = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("alumno/generarHistoriaAcademica", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


// PARA EL ENVIO DE CONSTANCIAS DE MAESTRIAS
export const getCatalogoMaestriasPosgrados = async () => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("maestriaDoctorado/getCatalogoMaestriaDoctorado", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const envioConstanciasMaestriaPosgrado = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "maestriaDoctorado/envioConstanciasPosgradoCSV",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Sin uso actual

export const changeIdiomaPreguntas = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post('preguntaEncuesta/cambiarIdioma',
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
}


export const cancellInscripcion = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post('inscripcion/cancelarInscripcion',
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
}